"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAMLocations = exports.defaultAMLocationData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultAMLocationData = exports.defaultAMLocationData = {
  id: null,
  name: ''
};
const getAMLocations = params => (0, _request.default)({
  url: '/am-locations',
  method: 'get',
  params
});
exports.getAMLocations = getAMLocations;